import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../auth/api";
import { alertSuccess, alertError } from "../../components/Alert";

// Fetch Area List Data (with stateID)
export const fetchAreaList = createAsyncThunk(
  "area/fetchAreaList",
  async (stateID, { rejectWithValue }) => {
    try {
      let response;
      // console.log(stateID);

      if (!stateID || stateID === "undefined") {
        response = await api.get(`/location/panel/AreaList`);
      } else {
        response = await api.get(`/location/panel/AreaList?stateID=${stateID}`);
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Add Area to the List
export const addAreaList = createAsyncThunk(
  "area/addAreaList",
  async (newAreaData, { rejectWithValue }) => {
    try {
      const response = await api.post("/location/panel/AreaList", newAreaData);
      alertSuccess(response.data.success);
      return newAreaData;
    } catch (error) {
      console.log(error.message);
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Update Area List Data
export const updateAreaList = createAsyncThunk(
  "area/updateAreaList",
  async (areaData, { rejectWithValue }) => {
    try {
      const response = await api.patch("/location/panel/AreaList", areaData);
      alertSuccess(response.data.success);
      return response.data;
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Area List Slice
const areaSlice = createSlice({
  name: "area",
  initialState: {
    areaList: [],
    status: "idle",
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Area List
      .addCase(fetchAreaList.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchAreaList.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.areaList = action.payload;
      })
      .addCase(fetchAreaList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Add Area
      .addCase(addAreaList.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addAreaList.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(addAreaList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Update Area List
      .addCase(updateAreaList.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updateAreaList.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(updateAreaList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { clearError } = areaSlice.actions;

export default areaSlice.reducer;
